import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton, TtIcon } from '@23/ui-react'

import { useFatalErrors } from './FatalError'

import './FatalError.scss'

const FatalErrorScreen = () => {
  const { message, reload } = useFatalErrors()

  return (
    <div className="fatal-error-screen">
      <div className="fatal-error-alert">
        <div className="fatal-error-header">
          <FormattedMessage defaultMessage="Error" />
        </div>
        <TtIcon className="fatal-error-icon" library="one" name="page-error" />
        <div className="fatal-error-message">{message}</div>
        {reload === 'ask' && (
          <TtButton
            color="secondary"
            variant="light"
            pill
            className="fatal-error-button"
            onClick={() => window.location.reload()}
          >
            <FormattedMessage defaultMessage="Reload" />
          </TtButton>
        )}
      </div>
    </div>
  )
}

export { FatalErrorScreen }
